var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3015",
    "data-name": "Group 3015",
    transform: "translate(-364 -169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    transform: "translate(364 169)",
    fill: "#6c70f0",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "live",
    d: "M173.994,239.39c-13.227,0-19.821,11.642-19.821,11.642a1.332,1.332,0,0,0,0,1.32S160.767,264,173.994,264s19.829-11.653,19.829-11.653a1.332,1.332,0,0,0,0-1.32s-6.6-11.642-19.829-11.642Zm0,5.481a6.821,6.821,0,1,1-6.773,6.822A6.824,6.824,0,0,1,173.994,244.871Zm0,2.669a4.153,4.153,0,1,0,4.112,4.153A4.108,4.108,0,0,0,173.994,247.54Z",
    transform: "translate(210.002 -62.39)",
    fill: "#6c70f0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlue);
export default __webpack_public_path__ + "static/media/eye_blue.3c4174bf250298dae02f8bc97694a966.svg";
export { ForwardRef as ReactComponent };